// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__15Wr4","right":"Footer_right__11wNg","buttons":"Footer_buttons__1qHDH"};